import { SortDirection } from '@busybusy/webapp-react-ui';
import _ from 'lodash';
import { SortOrder } from '__generated__/graphql';

function getSortFieldValue<T>(field: T) {
  if (typeof field === 'string') {
    return _.toLower(field);
  } else {
    return field;
  }
}
export function sortByField<T>(items: T[], key: keyof T, order: 'ASC' | 'DESC') {
  return _.orderBy(
    items,
    (item) => {
      const field = item[key];
      return getSortFieldValue(field);
    },
    convertTableSortToOrderBySort(order)
  );
}

export function sortByCustomField<T>(
  items: T[],
  key: keyof T,
  order: 'ASC' | 'DESC',
  getSortField: (item: T, key: keyof T) => any
) {
  return _.orderBy(
    items,
    (item) => {
      const field = getSortField(item, key);
      return getSortFieldValue(field);
    },
    convertTableSortToOrderBySort(order)
  );
}

export function convertTableSortToOrderBySort(order: 'ASC' | 'DESC') {
  return order === 'ASC' ? 'asc' : 'desc';
}

export function getApolloSortDirection(direction: SortDirection): SortOrder {
  switch (direction) {
    case SortDirection.ASCENDING:
      return SortOrder.Asc;
    case SortDirection.DESCENDING:
      return SortOrder.Desc;
    default:
      throw Error('Invalid direction passed to `getApolloSortValue.`');
  }
}
